"use client"

import cx from 'classnames';
import styles from './Tabs.module.css';

export type Tab = {
  label: string;
  value: string;
}

export const Tabs = ({
  value,
  onChange,
  tabs,
}: {
  value: string;
  onChange: (value: string) => void;
  tabs: Tab[];
}) => {
  return (
    <div className={styles.tabs}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          type="button"
          className={cx(styles.tab, {
            [styles.active]: value === tab.value,
          })}
          onClick={() => onChange(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
